import {
  getAXCommandCenterFeed,
} from './AXCommandCenterFeed';

export type AXRouterIntegrationStatus =
  | 'allow'
  | 'block';

export interface AXRouterIntegrationContract {
  readonly status: AXRouterIntegrationStatus;
  readonly governor: string;
  readonly verified: boolean;
  readonly generatedAt: string;
}

export function getAXRouterIntegrationContract():
AXRouterIntegrationContract {

  const feed =
    getAXCommandCenterFeed();

  return Object.freeze({
    status:
      feed.verified
        ? 'allow'
        : 'block',
    governor: 'AX Governor',
    verified: feed.verified,
    generatedAt: feed.generatedAt,
  });
}
